import { useNavigate } from "react-router-dom";
import "../App.css";

const PALETTE = [
  "#c0392b", "#2980b9", "#8e44ad", "#27ae60", "#d35400",
  "#1a5276", "#e74c3c", "#16a085", "#b7950b", "#6c3483",
];

function getCharacterColor(name) {
  const s = String(name).toLowerCase();
  const hash = [...s].reduce((acc, c) => acc + c.charCodeAt(0), 0);
  return PALETTE[hash % PALETTE.length];
}

function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const now = new Date();
  const diffDays = Math.floor((now - d) / (1000 * 60 * 60 * 24));
  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "Yesterday";
  if (diffDays < 7) return `${diffDays}d ago`;
  if (diffDays < 30) return `${Math.floor(diffDays / 7)}w ago`;
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
}

export default function BattlePreviewCard({
  id,
  char1,
  char2,
  winnerName,
  sceneImageUrl = null,
  battleCount = null,
  searchedAt = null,
}) {
  const navigate = useNavigate();
  const c1Color = getCharacterColor(char1);
  const c2Color = getCharacterColor(char2);
  const initial1 = String(char1 || "?")[0].toUpperCase();
  const initial2 = String(char2 || "?")[0].toUpperCase();

  const badge = battleCount != null
    ? `${battleCount} ${battleCount === 1 ? "BATTLE" : "BATTLES"}`
    : searchedAt
    ? formatDate(searchedAt)
    : null;

  return (
    <div className="bpc" onClick={() => navigate(`/battle/${id}`)} role="button" tabIndex={0}
      onKeyDown={e => e.key === "Enter" && navigate(`/battle/${id}`)}>

      {/* Background — scene image or color gradient */}
      <div
        className="bpc-bg"
        style={sceneImageUrl
          ? { backgroundImage: `url(${sceneImageUrl})` }
          : { background: `linear-gradient(135deg, ${c1Color} 0%, ${c2Color} 100%)` }
        }
      />
      <div className="bpc-overlay" />

      {/* Card body */}
      <div className="bpc-body">
        {/* Winner badge */}
        {winnerName && (
          <div className="bpc-winner-badge">
            <span className="bpc-dot" />
            {winnerName.toUpperCase()} WINS
          </div>
        )}

        {/* Arena — ghost initials + VS */}
        <div className="bpc-arena">
          <span className="bpc-ghost bpc-ghost-left">{initial1}</span>
          <span className="bpc-vs">VS</span>
          <span className="bpc-ghost bpc-ghost-right">{initial2}</span>
        </div>
      </div>

      {/* Footer */}
      <div className="bpc-footer">
        <span className="bpc-matchup">
          <strong>{char1}</strong>
          <span className="bpc-vs-text"> vs </span>
          <strong>{char2}</strong>
        </span>
        {badge && <span className="bpc-badge">{badge}</span>}
      </div>
    </div>
  );
}
